<div class="xlsx-csv-preview-dialog-content">
  <div class="xlsx-csv-preview-head">
    <h2>{{ 'uploadFilePreview' | translate }}</h2>
    <div
      class="close xlsx-csv-preview-close-btn"
      (click)="close()"
    >
      <i class="fa-solid fa-circle-xmark"></i>
    </div>
  </div>

  <div class="xlsx-csv-preview-body">
    <div
      *ngIf="!isEmpty; else emptyState"
      class="xlsx-csv-preview-table-wrapper"
    >
      <table class="xlsx-csv-preview-table">
        <thead>
          <tr>
            <th
              class="xlsx-csv-preview-table-index"
              scope="col"
            >
              {{ 'row' | translate }}
            </th>
            <th
              *ngFor="let header of preview?.headers"
              scope="col"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of preview?.rows; let i = index">
            <td class="xlsx-csv-preview-table-index">{{ i + 1 }}</td>
            <td *ngFor="let cell of row">{{ cell }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyState>
      <div class="xlsx-csv-preview-empty-state">
        <div class="xlsx-csv-preview-empty-state-message">
          <span>{{ 'dataManagement.emptyExcel' | translate }}</span>
          <span>{{ 'dataManagement.emptyExcelMessage' | translate }}</span>
        </div>
        <div class="xlsx-csv-preview-empty-state-image">
          <img
            ngSrc="assets/images/empty-list-5.svg"
            alt="empty"
            fill
          />
        </div>
      </div>
    </ng-template>
  </div>
</div>
